import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';

export const deleteOrganization = async (orgUuid: string): Promise<void> => {
  const url = `${apiUrl}deleteOrganization/`;
  const response = await postWithAuth(url, { OrgUUID: orgUuid });
  const data = await response.json();
  if (data?.Error) {
    throw new Error(data.Error);
  }
};
